import React, { useState } from "react";
import axios from '../../api/axios';

interface RatingModalProps {
  isOpen: boolean;
  onClose: () => void;
  doctorId: string;
  teleconsultId: string;
  patientId: string;
}


const RatingModal: React.FC<RatingModalProps> = ({ isOpen, onClose, doctorId, teleconsultId, patientId }) => {
  const [practitionerId, setPractitionerId] = useState(doctorId);
  const [consultationId, setConsultationId] = useState(teleconsultId);
  const [userPatientId, setUserPatientId] = useState(patientId);
  const [reviewDate, setReviewDate] = useState(new Date().toISOString()); 
  const [amountLike, setAmountLike] = useState(0);
  const [description, setDescription] = useState("");

  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  
  if (!isOpen) return null;

  const handleRating = (index: number) => {
    setAmountLike(index + 1);
  };  

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    try {
     const payload = {
        practitionerId: doctorId,
        patientId,
        consultationId: teleconsultId,
        reviewDate,
        amountLike,
        description,
      };
      await axios.post('/rating', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // setPractitionerId('');
      // setUserPatientId('');
      // setConsultationId('');
      // setReviewDate('');
      // setAmountLike(0);
      // setDescription('');

      onClose();
    } catch (error) {
      console.error('Failed to send feedback:', error);
    }
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-md p-4 bg-white rounded-lg shadow-lg">
        {/* Close Button */}
        <div className="flex items-center justify-end pb-3">
          <button className="z-50 cursor-pointer" onClick={onClose}>
            <svg
              className="text-black fill-current"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
          </button>
        </div>

        <form className="form-rate" onSubmit={handleSubmit}>
          <div className="flex flex-col items-center text-center">
            <h3 className="mb-4 text-lg text-center text-ls">
              Rate Your Experience
            </h3>
            <img
              className="w-20 sm:w-22 md:w-26 lg:w-30 xl:w-34 max-w-full object-contain"
              src="https://m.linksehat.com/assets/img/female.svg"
              alt="Illustration"
            />

            <div className="flex space-x-1">
              {[...Array(5)].map((_, index) => (
                <span
                  key={index}
                  className={`cursor-pointer text-2xl ${
                    amountLike > index ? "text-yellow-400" : "text-gray-300"
                  }`}
                  onClick={() => handleRating(index)}
                >
                  ★
                </span>
              ))}
            </div>

            {/* Notes */}
            <div className="w-full pb-2 my-5 border shadow-lg rounded-xl">
              <label
                className="block pt-2 pl-2 mb-2 text-sm font-bold text-gray-700"
                htmlFor="notes"
              >
                How was the consultation?
              </label>
              <textarea
                name="sNotes"
                id="notes"
                className="w-full px-3 py-2 leading-tight text-gray-700 focus:outline-none resize-none"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Write Here..."
              />
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-10 py-2 mr-2 border border-gray-500 rounded-full"
            >
              CANCEL
            </button>
            <button
              type="submit"
              className="px-10 py-2 rounded-full text-white bg-teal-500 border-b-4 border-white"
            >
              SEND
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RatingModal;
